import { supabase } from './supabase';
import { getClientSecurityContext } from './security';

export async function signInWithPassword(email: string, password: string) {
  return await supabase.auth.signInWithPassword({
    email,
    password,
  });
}

type AdminLoginResponse = {
  ok?: boolean;
  error?: string;
  reason?: string;
  blocked_until?: string | null;
  session?: {
    access_token: string;
    refresh_token: string;
    expires_at?: number | null;
    expires_in?: number | null;
    token_type?: string | null;
  } | null;
};

export async function signInToAdminPanel(email: string, password: string) {
  return await supabase.functions.invoke<AdminLoginResponse>('admin-login', {
    body: {
      email,
      password,
      client_context: getClientSecurityContext(),
    },
  });
}

export async function signOutUser() {
  return await supabase.auth.signOut();
}

export async function getCurrentSession() {
  return await supabase.auth.getSession();
}

export async function getCurrentUser() {
  return await supabase.auth.getUser();
}

export async function getMyProfile() {
  const { data: userResult, error: userError } = await supabase.auth.getUser();

  if (userError || !userResult.user) {
    return { data: null, error: userError };
  }

  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userResult.user.id)
    .single();

  return { data, error };
}
